import { A11yModule } from '@angular/cdk/a11y';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { BidiModule } from '@angular/cdk/bidi';
import { ObserversModule } from '@angular/cdk/observers';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { PortalModule } from '@angular/cdk/portal';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataSectionModule } from '@optsolservices/ngx-data-section';
import { DataTableModule } from '@optsolservices/ngx-data-table';
import { DataTableMasterDetailModule } from '@optsolservices/ngx-data-table-master-detail';
import { DataTableTabGroupModule } from '@optsolservices/ngx-data-table-tab-group';
import { DataTableWithSearchCriteriaModule } from '@optsolservices/ngx-data-table-with-search-criteria';
import { SearchCriteriaModule } from '@optsolservices/ngx-search-criteria';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { UploadsModule } from "@progress/kendo-angular-upload";
import { DEFAULT_DATE_FORMATS, SharedService } from './shared.service';
import { UserMenuPreviewDialogComponent } from './dynamic-dialogs/user-menu-preview-dialog/user-menu-preview-dialog.component';
import { SideMenuModule } from '@optsolservices/ngx-side-menu';
import { DetailSectionModule } from '@optsolservices/ngx-detail-section';
import { DetailSectionMasterDetailModule } from '@optsolservices/ngx-detail-section-master-detail';
import { OutgoingResultBinariesDialogComponent } from './dynamic-dialogs/outgoing-result-binaries-dialog/outgoing-result-binaries-dialog.component';
import 'hammerjs';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ConfirmDialogModule } from '@optsolservices/ngx-confirm-dialog';
import { IncomingMessageBinariesDialogComponent } from './dynamic-dialogs/incoming-message-binaries/incoming-message-binaries-dialog.component';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { OiGroupProcessDialogComponent } from './oi-group-process-dialog/oi-group-process-dialog.component';
import { ConfirmWithReasonDialogComponent } from './confirm-with-reason-dialog/confirm-with-reason-dialog.component';
import { PrintTriggerDialogComponent } from './print-trigger-dialog/print-trigger-dialog.component';
import { ScannerModule } from '@optsolservices/ngx-scanner';
import { ConfirmWithFreeTextReasonDialogComponent } from './confirm-with-free-text-reason-dialog/confirm-with-free-text-reason-dialog.component';
import { SurveyActionDialogComponent } from './survey-action-dialog/survey-action-dialog.component';
import { CallbackActionDialogComponent } from './callback-action-dialog/callback-action-dialog.component';
import { EmailFailedDeliveryActionDialogComponent } from './email-failed-delivery-action-dialog/email-failed-delivery-action-dialog.component';
import { EmailResendEmailDialogComponent } from './email-resend-email-dialog/email-resend-email-dialog.component';
import { ToDoListItemActionDialogComponent } from './todo-list-item-action-dialog/todo-list-item-action-dialog.component';

export const dynamicDialogs = [
  UserMenuPreviewDialogComponent,
  OutgoingResultBinariesDialogComponent,
  IncomingMessageBinariesDialogComponent,
  SurveyActionDialogComponent,
  CallbackActionDialogComponent,
  EmailFailedDeliveryActionDialogComponent,
  EmailResendEmailDialogComponent,
  ToDoListItemActionDialogComponent
];

export const optsolModules = [
  DataTableTabGroupModule,
  DataSectionModule,
  DataTableModule,
  DataTableWithSearchCriteriaModule,
  DataTableMasterDetailModule,
  SearchCriteriaModule,
  SideMenuModule,
  DetailSectionModule,
  DetailSectionMasterDetailModule,
  ConfirmDialogModule,
  ScannerModule
  // DataSectionGroupModule,
];

export const materialModules = [
  MatAutocompleteModule,
  MatButtonModule,
  MatBottomSheetModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatTableModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatBadgeModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSliderModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatNativeDateModule,
];

export const kendoModules = [
  LayoutModule,
  DateInputsModule,
  UploadsModule,
  TreeViewModule,
  GridModule,
  ExcelModule
];

export const miscModules = [
  CdkTableModule,
  A11yModule,
  BidiModule,
  CdkAccordionModule,
  ObserversModule,
  OverlayModule,
  PlatformModule,
  PortalModule,
  FlexLayoutModule,
  FormsModule,
  ReactiveFormsModule,
];

@NgModule({
  declarations: [
    ...dynamicDialogs,
    OiGroupProcessDialogComponent,
    ConfirmWithReasonDialogComponent,
    PrintTriggerDialogComponent,
    ConfirmWithFreeTextReasonDialogComponent
  ],
  imports: [
    CommonModule,
    ...optsolModules,
    ...materialModules,
    ...kendoModules,
    ...miscModules,
  ],
  exports: [
    ...optsolModules,
    ...materialModules,
    ...kendoModules,
    ...miscModules,
    CommonModule,
  ],
  providers: [
    SharedService,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {disableClose: true, hasBackdrop: true} },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [ MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS ]
    },
    { provide: MAT_DATE_FORMATS, useValue: DEFAULT_DATE_FORMATS },
  ],
})
export class SharedModule { }
